import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './tabAppRoot.html?raw';

import _WidgetBaseSP from 'more/_WidgetBaseSP';
import lang from 'dojo/_base/lang';
import GenericDialog from '../../../moreCore/UI/GenericDialog/GenericDialog';
import topic from 'dojo/topic';
import { teamsTabConfiguration } from "../teamTypes";
import teamsTabSetup from '../tabSetup/teamsTabSetup';
import teamsProjectCalendar from '../tabWidgets/projectCalendar/teamsProjectCalendar';
import { localStorage2SharedTeamsState } from "../localStorage2SharedTeamsState";
import projectCalendarSetup from '../tabWidgets/projectCalendarSetup/projectCalendarSetup';

class tabAppRoot extends compose(_WidgetBaseSP) {
    /*

        Anmerkung: Der eigentliche Application Code beginnt in _onTeamsInit();

    */
    templateString: any = template;

    private readonly teamsDevTabId: string = "dev_tab";

    private notAvailableContainer:HTMLDivElement;
    private mainContentContainer:HTMLDivElement;

    private currentWidget:any;
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
        this.postCreate_continue();
    }

    private async postCreate_continue(){
        this.StandbyStart();
        document.body.classList.add("msTeamsTabMode"); //da dieses widget nur in teams tab aufgerufen wird, koennen wir die css flag auch gleich hier sofort setzen
        let hasRole = await this.hasUserRoleAsync("TeamsIntegration_Access");
        this.StandbyStop();
        if (hasRole){
            topic.subscribe("MsTeamsIntegration/Authenticated", lang.hitch(this, this._onTeamsInit));
        }
        let isDev = false;
        if (window.location.origin.includes("localhost") || window.location.origin.includes("127.0.0.1")) {
            let hasDevRole = await this.hasUserRoleAsync("_DEV");
            if (hasDevRole) {
                isDev = true; //wir skippen den lock dlg, fuer die entwicklung
            }
        }


        if (isDev == false) {
            this.notAvailableContainer.classList.remove("w3-hide");
            this.mainContentContainer.classList.add("w3-hide");
        }else{
            console.info("displaying teamsIntegration in simulation mode vor development")
            topic.publish("MsTeamsIntegration/dev__overwriteTabId", this.teamsDevTabId);
            window.msTeamsSimpleApi.isCurrentlyRunningInTeamsTab = true;
            this._onTeamsInit();
        }
    }

    private async _onTeamsInit(){
        this._dev_setupShowDebugInfo();
        if ((this.hasUserRole("TeamsIntegration_Access") == false) || (window.msTeamsSimpleApi.isCurrentlyRunningInTeamsTab !== true)) {
            this.notAvailableContainer.classList.remove("w3-hide");
            this.mainContentContainer.classList.add("w3-hide");
            return;
        } else {
            this.notAvailableContainer.classList.add("w3-hide");
            this.mainContentContainer.classList.remove("w3-hide");
        }

        //checken ob
        //hier je nach context zeug machen. es koennen  eigene widgets im mainContentContainer gesetzt
        let tabConfigString: string = await window.msTeamsSimpleApi.helperFn.stateGet("system_tabConfiguration");
        if (tabConfigString.trim() == ""){
           tabConfigString = "{}";
        }
        let tabConfig:teamsTabConfiguration = JSON.parse(tabConfigString);
        if (tabConfig.hasOwnProperty("teamsTabWidgetName") == false){
            tabConfig["teamsTabWidgetName"] = "tabSetup";
            let reqProm:Promise<any> = new Promise((resolve, reject) => {
                this.RequestManager.callfunction(
                    "Webtool_MSTeams_TabAppHelpers_FirstStart_CheckTabEntity",
                    {
                        tabID:window.msTeamsSimpleApi.helperFn.getTabID(),
                        teamID:window.msTeamsSimpleApi?.metadata?.context?.team?.groupId ?? null,
                        channelID:window.msTeamsSimpleApi?.metadata?.context?.channel?.id ?? null
                    },
                    lang.hitch(this, (result:any) => {
                        resolve(result);
                    }),
                    lang.hitch(this, (err) => {
                        console.error(err.Message);
                        this.showToast(err.Message, "fas fa-bug");
                        reject(err);
                    })
                );
            });

            let isPreConfRes: { hasEntity: boolean, entityData?: TeamsTabApiData } = {hasEntity:false};
            try{
                isPreConfRes = await reqProm;
            }catch(e){
                console.error("Error fetching preconfiguration for tab...", e);
            }
            console.info("tab has preconfiguration:", isPreConfRes);

            if ((isPreConfRes?.hasEntity ?? false ) == true){
                if (typeof isPreConfRes?.entityData?.tabSpecialType == 'string'){
                    let targetType = (isPreConfRes?.entityData?.tabSpecialType as string ) ?? "tabSetup";
                    if (["projectCalendar"].includes(targetType)){ //erlaubte pre-configs
                        tabConfig.teamsTabWidgetName = targetType as any;
                        //config setzen
                        await window.msTeamsSimpleApi.helperFn.stateSet("system_tabConfiguration", JSON.stringify(tabConfig));
                    }
                }
            }
        }
        switch (tabConfig.teamsTabWidgetName){
            case 'tabSetup':
                topic.publish("MsTeamsIntegration/ToggleTabSettingsButton", false);
                let setupWidget = new teamsTabSetup();
                this.currentWidget = setupWidget;
                setupWidget.placeAt(this.mainContentContainer);
                break;
            case 'calendar':
                let calendarState = await window.msTeamsSimpleApi.helperFn.stateGet("ego_CalendarSettings");
                if (calendarState == ""){
                    try{
                        localStorage.removeItem("ego_CalendarSettings");
                    }catch{}
                }else{
                    try{
                        localStorage.setItem("ego_CalendarSettings", calendarState);
                    }catch{}
                }
                window.location.href = window.location.origin + window.appRoot + "Calendar"; //kein widget, wird durch css flags geregelt, siehe ".msTeamsTabModeSfC"
                break;
            case 'projectCalendar':
                let originalLocalStorage = window.localStorage;
                let fakeStorage = new localStorage2SharedTeamsState(
                    originalLocalStorage,
                    this.RequestManager,
                    window.msTeamsSimpleApi.helperFn.getTabID(),
                    null,
                    true
                );
                await fakeStorage.preLoadData(["WebCalendar_Autorefresh", "ego_CalendarSettings", "lastselected__week"]);
                window.localStorageShim = fakeStorage; //weil natuerlich kann man window.localStorage nicht ueberschreiben
                let projectCalendar = new teamsProjectCalendar();
                this.currentWidget = projectCalendar;
                projectCalendar.placeAt(this.mainContentContainer);
                break;
            case 'projectCalendarSetup':
                let projectCalendarSetupWidget = new projectCalendarSetup();
                this.currentWidget = projectCalendarSetupWidget;
                this.mainContentContainer.classList.add("w3-padding-64"); //ehhh...
                projectCalendarSetupWidget.placeAt(this.mainContentContainer);
                break;
            default:
                console.error("not implemented!", tabConfig);
                this.showToast(this.translate("General_UnknownError"), "far fa-dizzy");
                throw new Error("Not implemented.");
                break;
        }
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }


    // ######################################################################################################
    // ######################################################################################################
    // ######################################################################################################
    // developer helpers
    private async _dev_setupShowDebugInfo(){
        let hasDevRole: boolean = await this.hasUserRoleAsync("_DEV");
        if (typeof hasDevRole != 'boolean') {
            hasDevRole = false;
        }
        if (hasDevRole){
            let linkElementsInFooter = document.querySelectorAll("#mainFooter a"); // nds footer logo
            for (let linkElem of linkElementsInFooter as any as Array<HTMLAnchorElement>){
                linkElem.removeAttribute("href");
                linkElem.style.cursor = "help";
                linkElem.onclick = lang.hitch(this, this._dev_showDevInformation);
            }
        }
    }
    private async _dev_showDevInformation(){
        let devInfo:Object =  {};
        devInfo["currentContextFromTeams"] = window.msTeamsSimpleApi;
        devInfo["currentURL"] = window.location;
        devInfo["currentUserName"] = this.getCurrentUserName();
        devInfo["currentUserDisplayName"] = this.getCurrentUserDisplayName();
        devInfo["currentUserID"] = this.getCurrentUserId();

        let devInfoTxt: string = JSON.stringify(devInfo);
        try{
            await navigator.clipboard.writeText(devInfoTxt);
        }catch{}
        let devInfoDlg = new GenericDialog();
        devInfoDlg.destroyOnClose = true;
        let htmlContainer = document.createElement("div");
        htmlContainer.innerText = devInfoTxt;
        devInfoDlg.addButton("logout", this.translate("LoginForm__Logout"), lang.hitch(this, ()=>{
            let session = window.sessionInfo;
            session.closeSession();
        }));
        devInfoDlg.addButton("reload", this.translate("General_Reload"), lang.hitch(this, ()=>{
            try{
                (window.location.reload as (forcedReload?: boolean) => void)(true); //teams ist eigentlich immer in chrome
            }catch{
                window.location.reload(); //Ausnahme: safari iPhone...
            }
        }));
        devInfoDlg.addButton("redirectHome", "/home", lang.hitch(this, ()=>{
            window.location.href = window.location.href.replace("/TeamsIntegration", "/home"); //ganz billig
        }));
        devInfoDlg.show(htmlContainer, "dev info", null, null, 'close');
    }
}

export default mdsWidget(tabAppRoot);
